import apiService from '../services/apiService';
import alertActions from './alertActions';

const apiActions = {
	search(q) {
		return async dispatch => {
			try {
				dispatch({ type: 'SEARCH_REQUEST' });
				let res = await apiService.request('FoperatorSearch', { q });
				dispatch({ type: 'SEARCH_SUCCESS', results: res.results });
			}
			catch (err) {
				dispatch({ type: 'SEARCH_FAILURE', err });
				dispatch(alertActions.error(err.message));
			}
		}
	}
}

export default apiActions;



// WEBPACK FOOTER //
// ./src/actions/apiActions.js